import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import NBAInsightEntity from '../../entities/nba/NBAInsightEntity';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import NBABL from './NBABL';

class UpdateCard extends React.Component {
  constructor(props) {
    super(props);
    this.handleShowUpdateData = this.handleShowUpdateData.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.state = this.getState();
    this.updateList = [];
  }
  componentWillMount() {
    if (this.props.data.length === 1) {
      this.state = {
        modalHeading: this.props.data[0].textHeader,
        modalBody: this.props.data[0].textValue,
        modalFooter: this.props.data[0].isAction ? (
          <a
            aria-haspopup="true"
            id="A_0"
            href="javascript:;"
            onClick={this.handleAction}
            className="c-update__link"
          >
            {NBABL.getButtonText(this.props.data[0])}
          </a>
        ) : (
          ''
        ),
      };
    } else {
      _.forEach(this.props.data, (item, index) => {
        this.updateList.push(this.getUpdateItem(item, index));
      });
    }
  }
  getState() {
    return {
      show: false,
      modalHeading: '',
      modalBody: '',
      modalFooter: '',
    };
  }
  getUpdateItem(updateItem = new NBAInsightEntity(), index) {
    if (updateItem.textHeader) {
      return (
        <li className="c-update__list__item">
          <a
            aria-haspopup="true"
            href="javascript:;"
            className="c-update__link c-update__link--list-style"
            onClick={(e) => this.handleShowUpdateData(e, index)}
          >
            <h3 className="c-update__title c-update--many--title">
              {updateItem.textHeader}
            </h3>
          </a>
        </li>
      );
    } else {
      return null;
    }
  }
  handleAction(e) {
    e.preventDefault();
    const data = this.props.data[e.target.id.replace('A_', '')];
    this.props.action(data);
  }
  handleShowUpdateData(e, index) {
    e.preventDefault();
    const updateItem = this.props.data[index];
    this.setState({
      show: true,
      modalHeading: updateItem.textHeader,
      modalBody: updateItem.textValue,
      modalFooter: updateItem.isAction ? (
        <a
          aria-haspopup="true"
          target="_blank"
          id={`A_${index}`}
          href="javascript:;"
          onClick={this.handleAction}
          rel="noreferrer"
        >
          {NBABL.getButtonText(updateItem)}
        </a>
      ) : (
        ''
      ),
    });
  }
  render() {
    return this.props.data.length > 1 ? (
      <div className="l-tile c-update c-update--many">
        <ul className="c-update__list">{this.updateList}</ul>
        <PatternLibModalComponent
          show={this.state.show}
          onHide={() => this.setState({ show: false })}
          bsSize="medium"
          modalHeading={this.state.modalHeading}
          modalBody={this.state.modalBody}
          modalFooter={this.state.modalFooter}
          customClass="c-update-modal"
          scope={this}
        />
      </div>
    ) : (
      <div className="l-tile c-update c-update--single">
        <h3 className="c-update__title">{this.state.modalHeading}</h3>
        <p className="c-update__body">{this.state.modalBody}</p>
        {this.state.modalFooter ? (
          <div className="c-update__footer">{this.state.modalFooter}</div>
        ) : (
          ''
        )}
      </div>
    );
  }
}
UpdateCard.propTypes = {
  data: PropTypes.arrayOf(PropTypes.objectOf(NBAInsightEntity)).isRequired,
  action: PropTypes.func,
};
export default UpdateCard;
